import { useParams } from "react-router-dom";

import { useUIStateStore } from "@/store/uiStateStore";

import WritersForm from "./WritersForm";

function WritersCreate() {
  const isTunecore = useUIStateStore(state => state.isTunecore);
  const { id } = useParams();

  return (
    <div className="flex flex-wrap">
      <div className={`w-full ${isTunecore ? "bg-tunecore-black" : "bg-sentric-rebrand-light-grey"} lg:min-h-screen-minus-header`}>

        <WritersForm id={id} />

      </div>
    </div>
  );
}
export default WritersCreate;
